import { DamageType } from "./damageType";
import { ParticleEffect } from "./effects/particleEffect";
import type { ProjectileHittable } from "./interfaces";
import type { ParticleType } from "./particleType";
import { PhysicalThingWithHp } from "./physicalThingWithHp";
import type { Thing } from "./thing";
import type { XY } from "./xy";
import { ZOrder } from "./zOrder";

export abstract class DestroyableObstacle extends PhysicalThingWithHp implements ProjectileHittable {
	constructor(xy: XY) {
		super(xy, true);
		this.damageMultipliers.set(DamageType.BUBBLE, 0);
		this.damageMultipliers.set(DamageType.TOXIC_GAS, 0);
		this.damageMultipliers.set(DamageType.ELECTRIC, 0);
	}

	getDebrisParticleType(): ParticleType | null {
		return null;
	}

	getDebrisCount(): number {
		return 6;
	}

	protected onZeroHp(source: Thing | null, type: DamageType | null): void {
		const debrisType = this.getDebrisParticleType();
		if (debrisType) {
			this.board!.addEffect(new ParticleEffect(this.xy, debrisType, this.getDebrisCount()));
		}
		if (this.board) this.board.stats.recordObstacleDestroyed();
		super.onZeroHp(source, type);
	}

	getZOrder(): number {
		return ZOrder.SCENARIO;
	}

	onProjectileHit(_projectile: unknown): void {}

	isHittable(): boolean {
		return true;
	}
}
